var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconVideoOn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .video-on-class-a {\n                fill: none !important;\n            }\n\n            .video-on-class-b {\n                fill: #fff;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "video-on-class-a",
    d: "M0,0H32V32H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "video-on-class-b",
    d: "M19,8.973V20.867H5.667V8.973H19M20.333,6h-16A1.42,1.42,0,0,0,3,7.487V22.353A1.42,1.42,0,0,0,4.333,23.84h16a1.42,1.42,0,0,0,1.333-1.487v-5.2L27,23.1V6.743L21.667,12.69v-5.2A1.42,1.42,0,0,0,20.333,6Z",
    transform: "translate(1 1.08)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconVideoOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_video_on.094860f4d1c3f7b2c2aae4e579eff976.svg";